import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { withStyles } from '@mui/styles';
import { PatientType, PatientTypes } from 'doctivity-shared/utils';
import { MarketsUtil, withRouter } from 'utils';
import { Typography, Tabs, Tab } from '@mui/material';
import { ClaimsPage } from 'containers/pages';
import { setPatientType } from 'store/actions/appActions';
import { ClaimsSharedAffiliation } from './ClaimsSharedAffiliation';
import { setMarket } from 'store/actions/appActions';
import ServiceLineUtil from '../utils/ServiceLineUtil';
import { PayorChart } from 'market-data';
import { withReportCriteria } from 'market-data/useReportCriteria';

const styles = (theme) => ({
  container: {
    backgroundColor: theme.palette.primary.accent,
  },
  header: {
    padding: theme.spacing(3),
    paddingBottom: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
  },
  headerTitle: {
    color: '#FFFFFF',
    fontSize: 24,
    paddingRight: 30,
  },
  tabs: {
    paddingTop: 3,
    paddingLeft: theme.spacing(3),
    backgroundColor: theme.palette.primary.accent,
  },
  indicator: {
    backgroundColor: '#FFFFFF',
    height: 2,
    marginBottom: 8,
  },
  headerDivider: {},
  tabPanel: {
    color: '#E0E0E0',
    '&.Mui-selected': {
      color: '#FFFFFF',
    },
    '&:hover': {
      color: '#FFFFFF',
    },
  },
});


function getTabFromLocation(location) {
  const params      = new URLSearchParams(location.search);
  const report      = params.get('report');
  const patientType = (params.get('patientType') || 'all_patients').toUpperCase();

  if (!report || report === 'claims' || report === 'all_patients') {
    return patientType === PatientType.CAPTURED_CLAIMS
           ? 'captured_claims'
           : 'all_patients';
  }
  return report;
}

class ClaimsTabs extends React.Component {
  constructor(props) {
    super(props);
    
    // Restore from sessionStorage if available (survives navigation to other pages)
    this.lastStandardServiceline = this.loadFromSession('lastStandardServiceline');
    this.lastCapturedClaimsServiceline = this.loadFromSession('lastCapturedClaimsServiceline');
  }

  loadFromSession = (key) => {
    try {
      const value = sessionStorage.getItem(`claimsTabs.${key}`);
      if (!value) return null;
      return JSON.parse(value);
    } catch {
      return null;
    }
  };

  saveToSession = (key, value) => {
    try {
      if (value === null || value === undefined) {
        sessionStorage.removeItem(`claimsTabs.${key}`);
      } else {
        sessionStorage.setItem(`claimsTabs.${key}`, JSON.stringify(value));
      }
    } catch {
      // Ignore storage errors
    }
  };

 componentDidMount() {
    const { dispatch, currentCriteria } = this.props;
    const { patientType, market } = currentCriteria;

    // Check for custom SL mismatch (may need to wait for servicelines in componentDidUpdate)
    this.checkAndFixCustomServicelineMismatch();

    if (patientType) {
      if (this.props.patientType != patientType) {
        this.props.updateCriteria({ patientType: this.props.patientType });
        dispatch(setPatientType(this.props.patientType.toUpperCase()));
      } else {
        this.props.updateCriteria({ patientType: patientType });
        dispatch(setPatientType(patientType.toUpperCase()));
      }
    }
      

    if (market) {
      dispatch(setMarket(market));
    }

    //updateCriteria({ patientType });
   //this.onTabChange('','ALL_PATIENTS');
  }

componentDidUpdate(prevProps) {
    const { servicelines, clientId, router } = this.props;
    
    // When servicelines load, check for mismatch
    if (!prevProps.servicelines && this.props.servicelines) {
      this.checkAndFixCustomServicelineMismatch();
    }

    // When serviceline changes on non-Captured Claims tabs, sync to Captured Claims
    const params = new URLSearchParams(router.location.search);
    const prevParams = new URLSearchParams(prevProps.router.location.search);
    
    const currentSlParam = params.get('serviceline');
    const prevSlParam = prevParams.get('serviceline');
    
    console.log('componentDidUpdate - currentSlParam:', currentSlParam, 'prevSlParam:', prevSlParam);
    
    // Only proceed if URL serviceline actually changed
    if (currentSlParam !== prevSlParam && currentSlParam) {
      const tab = getTabFromLocation(router.location);
      const isNonCapturedClaimsTab = tab !== 'captured_claims' && tab !== 'payors';
      
      console.log('SL changed - tab:', tab, 'isNonCapturedClaimsTab:', isNonCapturedClaimsTab);
      
      if (isNonCapturedClaimsTab && servicelines && servicelines.length > 0) {
        // Parse the serviceline from URL
        const currentServiceline = currentSlParam.includes(',') 
          ? currentSlParam.split(',').map(id => parseInt(id, 10))
          : parseInt(currentSlParam, 10);
        
        const slId = Array.isArray(currentServiceline) ? currentServiceline[0] : currentServiceline;
        
        console.log('Checking if custom SL - slId:', slId);
        
        // Only sync standard servicelines (not custom ones)
        if (!this.isCustomServiceLine(slId, servicelines, clientId)) {
          console.log('Saving to session - slId:', slId);
          
          // Sync to Captured Claims (wrap in array format)
          this.lastCapturedClaimsServiceline = Array.isArray(currentServiceline) 
            ? [...currentServiceline] 
            : [currentServiceline];
          this.saveToSession('lastCapturedClaimsServiceline', this.lastCapturedClaimsServiceline);
          
          // Also update lastStandardServiceline
          this.lastStandardServiceline = slId;
          this.saveToSession('lastStandardServiceline', this.lastStandardServiceline);
        }
      }
    }
  }
  checkAndFixCustomServicelineMismatch = () => {
    const { servicelines, clientId, currentCriteria, router } = this.props;
    const { serviceline } = currentCriteria;
    
    // Can't check yet if servicelines not loaded
    if (!servicelines || servicelines.length === 0) {
      return;
    }
    
    const tab = getTabFromLocation(router.location);
    const isNonCapturedClaimsTab = tab !== 'captured_claims' && tab !== 'payors';
    
    if (isNonCapturedClaimsTab && serviceline) {
      const hasCustomSL = this.isCustomServiceLine(serviceline, servicelines, clientId);
      
      if (hasCustomSL) {
        // Save it for when they go back to Captured Claims
        this.lastCapturedClaimsServiceline = Array.isArray(serviceline) 
          ? [...serviceline] 
          : [serviceline];
        this.saveToSession('lastCapturedClaimsServiceline', this.lastCapturedClaimsServiceline);
        
        // Switch to a standard serviceline
        const newServiceline = this.lastStandardServiceline || ServiceLineUtil.getDefault();
        this.props.updateCriteria({ serviceline: newServiceline });
      }
    }
  };

  /**
   * Check if a service line ID is a custom service line (belongs to the current client)
   */
  isCustomServiceLine = (servicelineId, servicelines, clientId) => {
    if (!servicelines || !servicelineId || !clientId) {
      return false;
    }
    
    // Handle array of serviceline IDs
    const ids = Array.isArray(servicelineId) ? servicelineId : [servicelineId];
    
    for (const id of ids) {
      // Skip special values
      if (id === 'all' || id === 'codes') {
        continue;
      }
      
      // Find the service line in the list
      const serviceline = ServiceLineUtil.findServiceLine(servicelines, id);
      if (serviceline && serviceline.client_id === clientId) {
        return true;
      }
    }
    
    return false;
  };

  /**
   * Get the first standard (non-custom) service line from a selection
   * Returns null if none found
   */
  getFirstStandardServiceline = (servicelineIds, servicelines, clientId) => {
    if (!servicelines || !servicelineIds) {
      return null;
    }
    
    const ids = Array.isArray(servicelineIds) ? servicelineIds : [servicelineIds];
    
    for (const id of ids) {
      if (id === 'all' || id === 'codes') {
        continue;
      }
      
      const serviceline = ServiceLineUtil.findServiceLine(servicelines, id);
      // Standard service lines have no client_id
      if (serviceline && serviceline.client_id == null) {
        return id;
      }
    }
    
    return null;
  };

  render() {
    
    const { classes, router, currentCriteria } = this.props;

    // pick the selected tab straight from the URL
    const tab = getTabFromLocation(router.location);


//    if (tab==='claims') {
  //    tab='captured_claims';
//    }

    let tabContent = <></>;
    switch (tab) {
      case 'shared_affiliation':
        tabContent = (
          <ClaimsSharedAffiliation
            query={currentCriteria}
            router={this.props.router}
          />
        );
        break;
      case 'payors':
        tabContent = <PayorChart 
        />;
        break;
      default:
        tabContent = (
          <ClaimsPage query={currentCriteria} router={this.props.router} />
        );
    }

    return (
      <>
        <div className={classes.container}>
          <title>Market Data</title>
          <div className={classes.header}>
            <Typography className={classes.headerTitle}>Market Data</Typography>
          </div>
          <Tabs
            variant='scrollable'
            className={classes.tabs}
            TabIndicatorProps={{ className: classes.indicator }}
            value={tab}
            onChange={this.onTabChange}
          >
            <Tab
              className={classes.tabPanel}
              label='Projected Patients'
              value={PatientType.ALL_PATIENTS.toLowerCase()}
              disableRipple
            />
            <Tab
              className={classes.tabPanel}
              label='Captured Claims'
              value={'captured_claims'}
              disableRipple
            />
            <Tab
              className={classes.tabPanel}
              label='Shared Affiliation'
              value='shared_affiliation'
              disableRipple
            />
            <Tab
              className={classes.tabPanel}
              label='Payors'
              value='payors'
              disableRipple
            />
          </Tabs>
        </div>
        {tabContent}
      </>
    );
  }

  onTabChange = (_, newValue) => {
    const { servicelines, clientId, currentCriteria, router } = this.props;
    
    // Get current tab to detect transitions
    const currentTab = getTabFromLocation(router.location);
    const wasOnCapturedClaims = currentTab === 'captured_claims';
    const goingToCapturedClaims = newValue === 'captured_claims';
    const wasOnPayors = currentTab === 'payors';
    const goingToPayors = newValue === 'payors';
    
    let report;
    let remainder = {};
    
    // Get serviceline from criteria OR directly from URL as fallback
    let serviceline = currentCriteria?.serviceline;
    if (serviceline === undefined) {
      const params = new URLSearchParams(router.location.search);
      const slParam = params.get('serviceline');
      if (slParam) {
        if (slParam.includes(',')) {
          serviceline = slParam.split(',').map(id => parseInt(id, 10));
        } else {
          serviceline = parseInt(slParam, 10);
        }
      }
    }

    // GUARD: If servicelines aren't loaded yet, we can't check if current SL is custom
    // Use safe defaults based on destination tab
    if (!servicelines || servicelines.length === 0) {
      if (!goingToCapturedClaims && !goingToPayors) {
        // Going to Projected Patients or Shared Affiliation
        // Can't verify if current SL is custom, so use saved standard or default
        serviceline = this.lastStandardServiceline || ServiceLineUtil.getDefault();
      } else if (goingToCapturedClaims) {
        // Going to Captured Claims - use saved or convert to array
        if (this.lastCapturedClaimsServiceline && this.lastCapturedClaimsServiceline.length > 0) {
          serviceline = [...this.lastCapturedClaimsServiceline];
        } else if (serviceline && serviceline !== 'all') {
          serviceline = Array.isArray(serviceline) ? serviceline : [serviceline];
        } else {
          serviceline = [ServiceLineUtil.getDefault()];
        }
      }
      // Payors doesn't care about serviceline, leave as-is
      
      report = newValue === 'shared_affiliation' ? 'shared_affiliation' 
            : newValue === 'payors' ? 'payors' 
            : newValue;
      const safePatientType = derivePatientType(report, this.props.patientType);
      this.props.updateCriteria({ report, serviceline, patientType: safePatientType });
      return;
    }

    // Handle the service line switching logic for ALL tab changes
    // Payors doesn't have a serviceline select, so we handle it specially
    
    if (wasOnCapturedClaims && !goingToCapturedClaims) {
      // We're leaving Captured Claims
      // Save the current Captured Claims selection (could be custom or standard)
      if (serviceline && serviceline !== 'all') {
        this.lastCapturedClaimsServiceline = Array.isArray(serviceline) 
          ? [...serviceline] 
          : [serviceline];
        this.saveToSession('lastCapturedClaimsServiceline', this.lastCapturedClaimsServiceline);
      }
      
      if (!goingToPayors) {
        // Only transform serviceline if NOT going to Payors (Payors doesn't use it)
        const hasCustomSL = this.isCustomServiceLine(serviceline, servicelines, clientId);
        
        if (hasCustomSL) {
          // Try to get a standard service line from the current selection
          const standardSL = this.getFirstStandardServiceline(serviceline, servicelines, clientId);
          
          if (standardSL) {
            serviceline = standardSL;
          } else if (this.lastStandardServiceline) {
            serviceline = this.lastStandardServiceline;
          } else {
            serviceline = ServiceLineUtil.getDefault();
          }
        } else if (Array.isArray(serviceline) && serviceline.length > 0) {
          // Not a custom SL but is an array - take first element for non-multiple mode
          serviceline = serviceline[0];
        }
      }
      // If going to Payors, leave serviceline as-is (it won't be displayed anyway)
      
    } else if (wasOnPayors && !goingToPayors) {
      // Leaving Payors - restore appropriate serviceline for destination
      if (goingToCapturedClaims) {
        // Restore saved Captured Claims selection
        if (this.lastCapturedClaimsServiceline && this.lastCapturedClaimsServiceline.length > 0) {
          serviceline = [...this.lastCapturedClaimsServiceline];
        } else if (this.lastStandardServiceline) {
          serviceline = [this.lastStandardServiceline];
        } else {
          serviceline = [ServiceLineUtil.getDefault()];
        }
      } else {
        // Going to a non-Captured Claims tab (Projected Patients or Shared Affiliation)
        if (this.lastStandardServiceline) {
          serviceline = this.lastStandardServiceline;
        } else {
          serviceline = ServiceLineUtil.getDefault();
        }
      }
      
    } else if (!wasOnCapturedClaims && !wasOnPayors && goingToCapturedClaims) {
      // Going TO Captured Claims from Projected Patients or Shared Affiliation
      // Remember the current standard service line before switching
      if (serviceline && serviceline !== 'all') {
        const slId = Array.isArray(serviceline) ? serviceline[0] : serviceline;
        if (!this.isCustomServiceLine(slId, servicelines, clientId)) {
          this.lastStandardServiceline = slId;
          this.saveToSession('lastStandardServiceline', this.lastStandardServiceline);
        }
      }
      
      // Restore saved Captured Claims selection if available
      if (this.lastCapturedClaimsServiceline && this.lastCapturedClaimsServiceline.length > 0) {
        serviceline = [...this.lastCapturedClaimsServiceline];
      } else {
        // No saved selection - convert current to array format
        if (serviceline === 'all' || (Array.isArray(serviceline) && serviceline?.[0] === 'all')) {
          serviceline = [ServiceLineUtil.getDefault()];
        } else if (!Array.isArray(serviceline)) {
          serviceline = serviceline ? [serviceline] : [ServiceLineUtil.getDefault()];
        }
      }
      
    } else if (!wasOnCapturedClaims && !wasOnPayors && !goingToCapturedClaims && !goingToPayors) {
      // Switching between Projected Patients and Shared Affiliation
      if (serviceline === 'all' || (Array.isArray(serviceline) && serviceline?.[0] === 'all')) {
        serviceline = ServiceLineUtil.getDefault();
      } else if (Array.isArray(serviceline) && serviceline.length > 0) {
        serviceline = serviceline[0];
      }
      // Remember this as the last standard serviceline
      if (serviceline && serviceline !== 'all') {
        this.lastStandardServiceline = serviceline;
        this.saveToSession('lastStandardServiceline', this.lastStandardServiceline);
      }
      
    } else if (!wasOnCapturedClaims && !wasOnPayors && goingToPayors) {
      // Going TO Payors from Projected Patients or Shared Affiliation
      // Save current standard serviceline
      if (serviceline && serviceline !== 'all') {
        const slId = Array.isArray(serviceline) ? serviceline[0] : serviceline;
        if (!this.isCustomServiceLine(slId, servicelines, clientId)) {
          this.lastStandardServiceline = slId;
          this.saveToSession('lastStandardServiceline', this.lastStandardServiceline);
        }
      }
      // Leave serviceline as-is (Payors doesn't use it)
      
    } else {
      // Default case (e.g., staying on same tab) - handle 'all' case
      if (serviceline === 'all' || (Array.isArray(serviceline) && serviceline?.[0] === 'all')) {
        serviceline = ServiceLineUtil.getDefault();
      }
    }
    
    switch (newValue) {
      case 'shared_affiliation':
        report = 'shared_affiliation';
        break;
      case 'payors':
        report = 'payors';
        break;
      default:
        report = newValue;
        break;
    }
    
    // Always include serviceline and patientType in the update
    const safePatientType = derivePatientType(report, this.props.patientType);
    remainder = { serviceline, patientType: safePatientType };
    
    this.props.updateCriteria({ report, ...remainder });
  };

  OLDonTabChange = (_, newValue) => {
      const { servicelines, clientId, currentCriteria, router } = this.props;
      
      // Get current tab to detect transitions
      const currentTab = getTabFromLocation(router.location);
      const wasOnCapturedClaims = currentTab === 'captured_claims';
      const goingToCapturedClaims = newValue === 'captured_claims';
      const wasOnPayors = currentTab === 'payors';
      const goingToPayors = newValue === 'payors';
      
      let report;
      let remainder = {};
      let { serviceline } = currentCriteria;
      
// If servicelines aren't loaded yet, defer the check
  if (!servicelines || servicelines.length === 0) {
    // Still allow the tab change, but force a safe default for non-CC tabs
    const goingToCapturedClaims = newValue === 'captured_claims';
    const goingToPayors = newValue === 'payors';
    
    if (!goingToCapturedClaims && !goingToPayors) {
      // Can't verify if SL is custom, so use saved standard or default
      const serviceline = this.lastStandardServiceline || ServiceLineUtil.getDefault();
      const safePatientType = derivePatientType(newValue, this.props.patientType);
      this.props.updateCriteria({ report: newValue, serviceline, patientType: safePatientType });
      return;
    }
  }


      // Handle the service line switching logic for ALL tab changes
      // Payors doesn't have a serviceline select, so we handle it specially
      
      if (wasOnCapturedClaims && !goingToCapturedClaims) {
        // We're leaving Captured Claims
        // Save the current Captured Claims selection (could be custom or standard)
        if (serviceline && serviceline !== 'all') {
          this.lastCapturedClaimsServiceline = Array.isArray(serviceline) 
            ? [...serviceline] 
            : [serviceline];
          this.saveToSession('lastCapturedClaimsServiceline', this.lastCapturedClaimsServiceline);
        }
        
        if (!goingToPayors) {
          // Only transform serviceline if NOT going to Payors (Payors doesn't use it)
          const hasCustomSL = this.isCustomServiceLine(serviceline, servicelines, clientId);
          
          if (hasCustomSL) {
            // Try to get a standard service line from the current selection
            const standardSL = this.getFirstStandardServiceline(serviceline, servicelines, clientId);
            
            if (standardSL) {
              serviceline = standardSL;
            } else if (this.lastStandardServiceline) {
              serviceline = this.lastStandardServiceline;
            } else {
              serviceline = ServiceLineUtil.getDefault();
            }
          } else if (Array.isArray(serviceline) && serviceline.length > 0) {
            // Not a custom SL but is an array - take first element for non-multiple mode
            serviceline = serviceline[0];
          }
        }
        // If going to Payors, leave serviceline as-is (it won't be displayed anyway)
        
      } else if (wasOnPayors && !goingToPayors) {
        // Leaving Payors - restore appropriate serviceline for destination
        if (goingToCapturedClaims) {
          // Restore saved Captured Claims selection
          if (this.lastCapturedClaimsServiceline && this.lastCapturedClaimsServiceline.length > 0) {
            serviceline = [...this.lastCapturedClaimsServiceline];
          } else if (this.lastStandardServiceline) {
            serviceline = [this.lastStandardServiceline];
          } else {
            serviceline = [ServiceLineUtil.getDefault()];
          }
        } else {
          // Going to a non-Captured Claims tab (Projected Patients or Shared Affiliation)
          if (this.lastStandardServiceline) {
            serviceline = this.lastStandardServiceline;
          } else {
            serviceline = ServiceLineUtil.getDefault();
          }
        }
        
      } else if (!wasOnCapturedClaims && !wasOnPayors && goingToCapturedClaims) {
        // Going TO Captured Claims from Projected Patients or Shared Affiliation
        // Remember the current standard service line before switching
        if (serviceline && serviceline !== 'all') {
          const slId = Array.isArray(serviceline) ? serviceline[0] : serviceline;
          if (!this.isCustomServiceLine(slId, servicelines, clientId)) {
            this.lastStandardServiceline = slId;
            this.saveToSession('lastStandardServiceline', this.lastStandardServiceline);
          }
        }
        
        // Restore saved Captured Claims selection if available
        if (this.lastCapturedClaimsServiceline && this.lastCapturedClaimsServiceline.length > 0) {
          serviceline = [...this.lastCapturedClaimsServiceline];
        } else {
          // No saved selection - convert current to array format
          if (serviceline === 'all' || (Array.isArray(serviceline) && serviceline?.[0] === 'all')) {
            serviceline = [ServiceLineUtil.getDefault()];
          } else if (!Array.isArray(serviceline)) {
            serviceline = serviceline ? [serviceline] : [ServiceLineUtil.getDefault()];
          }
        }
        
      } else if (!wasOnCapturedClaims && !wasOnPayors && !goingToCapturedClaims && !goingToPayors) {
        // Switching between Projected Patients and Shared Affiliation
        if (serviceline === 'all' || (Array.isArray(serviceline) && serviceline?.[0] === 'all')) {
          serviceline = ServiceLineUtil.getDefault();
        } else if (Array.isArray(serviceline) && serviceline.length > 0) {
          serviceline = serviceline[0];
        }
        // Remember this as the last standard serviceline
        if (serviceline && serviceline !== 'all') {
          this.lastStandardServiceline = serviceline;
          this.saveToSession('lastStandardServiceline', this.lastStandardServiceline);
        }
        
      } else if (!wasOnCapturedClaims && !wasOnPayors && goingToPayors) {
        // Going TO Payors from Projected Patients or Shared Affiliation
        // Save current standard serviceline
        if (serviceline && serviceline !== 'all') {
          const slId = Array.isArray(serviceline) ? serviceline[0] : serviceline;
          if (!this.isCustomServiceLine(slId, servicelines, clientId)) {
            this.lastStandardServiceline = slId;
            this.saveToSession('lastStandardServiceline', this.lastStandardServiceline);
          }
        }
        // Leave serviceline as-is (Payors doesn't use it)
        
      } else {
        // Default case (e.g., staying on same tab) - handle 'all' case
        if (serviceline === 'all' || (Array.isArray(serviceline) && serviceline?.[0] === 'all')) {
          serviceline = ServiceLineUtil.getDefault();
        }
      }
      
      switch (newValue) {
        case 'shared_affiliation':
          report = 'shared_affiliation';
          break;
        case 'payors':
          report = 'payors';
          break;
        default:
          report = newValue;
          break;
      }
      
      // Always include serviceline and patientType in the update
      const safePatientType = derivePatientType(report, this.props.patientType);
      remainder = { serviceline, patientType: safePatientType };
      
      this.props.updateCriteria({ report, ...remainder });
  };
  
}

ClaimsTabs.propTypes = {
  router: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  patientType: PropTypes.oneOf(PatientTypes),
  claimsType: PropTypes.object,
  market: PropTypes.object,
  user: PropTypes.object,
  classes: PropTypes.object,
  updateCriteria: PropTypes.func.isRequired,
  currentCriteria: PropTypes.object.isRequired,
  getCriteria: PropTypes.func.isRequired,
  servicelines: PropTypes.array,
  clientId: PropTypes.number,
};

function mapStateToProps(state) {
  return {
    patientType: state.app.patientType,
    clientType: state.app.clientType,
    market: MarketsUtil.getSelectedMarket(state),
    user: state.user,
    servicelines: state.claims && state.claims.servicelines_grouped,
    clientId: state.app.selectedClient,
  };
}

function derivePatientType(report, previous) {
  if (report === 'captured_claims') {
    return PatientType.CAPTURED_CLAIMS.toLowerCase()
  }

  // Allowed non-claims patient types
  const validNonClaimTypes = [
    PatientType.ALL_PATIENTS.toLowerCase(),
    PatientType.PEDIATRIC_PATIENTS.toLowerCase(),
  ];

  return validNonClaimTypes.includes(previous)
    ? (previous)
    : PatientType.ALL_PATIENTS.toLowerCase();
}

const styled = withStyles(styles)(withReportCriteria('', ClaimsTabs));
const connected = connect(mapStateToProps)(styled);
const routed = withRouter(connected);
export { routed as ClaimsTabs };